export const legacyRoutes = [
  { legacyPath: "/index.html", target: "/en/programs", status: 301 },
  { legacyPath: "/index-0.html", target: "/en/programs", status: 301 },
  { legacyPath: "/index-2.html", target: "/en/programs", status: 301 },
  { legacyPath: "/index-3.html", target: "/en/programs", status: 301 },
  { legacyPath: "/articles.html", target: "/en/articles", status: 301 },
  { legacyPath: "/articles-2.html", target: "/en/articles", status: 301 },
  { legacyPath: "/articles-3.html", target: "/en/articles", status: 301 },
  { legacyPath: "/media.html", target: "/en/media", status: 301 },
  { legacyPath: "/media-2.html", target: "/en/media/eigen-pad-season-1-threshold", status: 301 },
  { legacyPath: "/media-3.html", target: "/en/media/eigen-pad-season-2-descent", status: 301 },
  { legacyPath: "/media-4.html", target: "/en/media/eigen-pad-season-3-foundation", status: 301 },
  { legacyPath: "/media-5.html", target: "/en/media/eigen-pad-season-4-the-map", status: 301 },
  { legacyPath: "/media-6.html", target: "/en/media/eigen-pad-season-5-the-shadow", status: 301 },
  { legacyPath: "/media-7.html", target: "/en/media/eigen-pad-season-6-the-myth", status: 301 },
  { legacyPath: "/media-videos.html", target: "/en/media/other-videos", status: 301 },
  { legacyPath: "/media-live.html", target: "/en/events", status: 301 },
  { legacyPath: "/media-pika.html", target: "/en/media/pika-pika-talkshow", status: 301 },
  { legacyPath: "/library.html", target: "/en/library", status: 301 },
  { legacyPath: "/bio.html", target: "/en/about", status: 301 },
  { legacyPath: "/about.html", target: "/en/about", status: 301 },
  { legacyPath: "/contact.html", target: "/en/about", status: 301 },
  { legacyPath: "/donations.html", target: "/en/donate", status: 301 },
  { legacyPath: "/single-post.html", target: "/en/articles", status: 301 },
  { legacyPath: "/s2-promo.html", target: "/en/programs", status: 301 }
];
